(function (angular) {
	'use strict';

	angular
		.module('investorDashboard')
		.controller('DashboardPerformanceAllTime', [
			'globalConfig',
			'DashboardPerformanceService',
			DashboardPerformanceAllTimeFunction
		]);

	function DashboardPerformanceAllTimeFunction(
		globalConfig,
		DashboardPerformanceService
	) {
		var dashboard = this;
		
		dashboard.$onInit = function() {
			dashboard.loadingPerformance = true;
			angular.extend(dashboard, globalConfig);

			DashboardPerformanceService.getPerformanceData(true)
				.then(function(performanceData) {
					angular.extend(dashboard, performanceData);
					dashboard.loadingPerformance = false;

					if(angular.isDefined(dashboard.accountBreakdown)) {
						dashboard.accountBreakdown.activeMobileColumn = 'All time';
					} else {
						dashboard.accountBreakdown = {};
					}
					
					if(angular.isDefined(dashboard.priorYearReturns)) {
						dashboard.priorYearReturns.activeMobileColumn = 'All time';
						dashboard.priorYearReturns.selectedViewFormat = 'returnAsPercentage';
					} else {
						dashboard.priorYearReturns = {};
					}
				});
		};
	}
})(window.angular);